<template>
  <div class="analysis-studio">
    <ProgressView v-if="isRequestInProgress" />
    <!-- <ProgressView v-if="isRequestInProgress" top="60" /> -->
    <div class="layout-grid">
      <TopBar
        @showTable="showTable = true"
        @showMap="showTable = false"
        @toggleSearch="toggleGeoSearch"
        @clickShare="toggleSharePopup"
        :showTable="showTable"
      />
      <div class="content-layout">
        <LayersPanel />
        <div class="content-area">
          <DeckGL
            :accessToken="accessToken"
            :layers="layers"
            :latitude="latitude"
            :longitude="longitude"
            :zoom="zoom"
            :showZoomControls="true"
            :updateViewStateOnLayersChange="false"
            @onClick="handleClick"
            @onDragStart="closePopUp"
          />
          <GeoPopup
            v-if="popUpData && popUpData.show"
            :icon="popUpData.icon"
            :title="popUpData.title"
            :value="popUpData.value"
            :metadata="popUpData.metadata"
            :pinned="popUpData.pinned"
            :x="popUpData.x"
            :y="popUpData.y"
          />
          <!-- <StaticGeoPopup
            :data="popUpData"
            @close="popUpData = { show: false }"
            v-click-outside="() => (popUpData = { show: false })"
          /> -->
          <!-- v-click-outside="() => (popUpData = { show: false })" -->
          <CommentView />
          <CommentBox />
          <DetailsPanel />
          <TimeLineView />
          <ContextMenu
            :data="contextData"
            @close="closeContext"
            @addComment="(data) => showAddCommentPopup(data)"
          />
        </div>
        <SlideYDownTransition>
          <TableView v-show="showTable" @close="showTable = false" />
        </SlideYDownTransition>
      </div>
    </div>
    <SlideYUpTransition>
      <GeoSearch
        v-if="showGeoSearch"
        :entities="getEntitiesForSearch"
        @clickClose="toggleGeoSearch"
        @select="handleGeoSelection"
      />
    </SlideYUpTransition>
    <portal-target name="analysisStudio">
      <!-- Target for all the modals related to Analysis Studio (Static Entity Analysis) -->
    </portal-target>
    <portal to="app">
      <SlideYUpTransition>
        <ShareConsolePopup
          v-if="showSharePopup"
          :dashboard_id="parseInt(getCurrentConsole.id)"
          :dashboard_name="'Static Asset Performance Analysis'"
          :magic_link="magic_link"
          :target_type="'analysis'"
          @createLink="(link) => changeMagicLink(link)"
          @removeLink="changeMagicLink(null)"
          @close="toggleSharePopup"
        />
      </SlideYUpTransition>
    </portal>
  </div>
</template>

<script>
import TopBar from "@/components/static_entity_analysis/containers/TopBar";
import DeckGL from "@/components/global/views/DeckGL";
import LayersPanel from "@/components/static_entity_analysis/containers/LayersPanel";
import DetailsPanel from "@/components/static_entity_analysis/containers/DetailsPanel";
import TimeLineView from "@/components/static_entity_analysis/containers/TimeLineView";
import TableView from "@/components/static_entity_analysis/containers/TableView";
import DistanceToolLayer from "@/layers/DistanceToolLayer";
import { SlideYDownTransition, SlideYUpTransition } from "vue2-transitions";
import { ScatterplotLayer, TextLayer, PathLayer } from "@deck.gl/layers";
import { WebMercatorViewport } from "@deck.gl/core";
import { mapGetters, mapActions } from "vuex";
import GeoSearch from "@/modules/GeoSearch";
import GeoPopup from "@/modules/GeoPopup";
import ContextMenu from "@/components/global/views/ContextMenu";
import City from "@/models/City.model";
import ShareConsolePopup from "@/components/console/modals/ShareConsolePopup";
import CommentBox from "@/components/global/views/CommentBox";
import CommentView from "@/components/global/views/CommentView";
import { IconLayer } from "@deck.gl/layers";

export default {
  components: {
    TopBar,
    DeckGL,
    LayersPanel,
    DetailsPanel,
    TimeLineView,
    TableView,
    SlideYDownTransition,
    SlideYUpTransition,
    GeoSearch,
    ContextMenu,
    GeoPopup,
    ShareConsolePopup,
    CommentBox,
    CommentView,
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiaGF4emllIiwiYSI6ImNqZ2c2NWp3OTBxenAzM3FzeThydmZ0YncifQ.584ugILuKFfDPTxqyiO_0g",
      showTable: false,
      selectedStaticEntities: [],
      popUpData: {},
      contextData: {},
      latitude: 12.9141,
      longitude: 74.856,
      zoom: 12,
      layers: [],
      showGeoSearch: false,
      watchActiveCity: true,
      showSharePopup: false,
      magic_link: null,
      showMeasureDisatanceTool: false,
      measure_data: null,
    };
  },
  computed: {
    ...mapGetters("StaticEntity", [
      "getStaticEntities",
      "getCurrentConsole",
      "isMeasureModeEnabled",
    ]),
    ...mapGetters("Layers", ["getActiveLayers", "getLayers"]),
    ...mapGetters("Data", ["isRequestInProgress"]),
    ...mapGetters("Location", ["getActiveCity"]),
    // ...mapGetters("Entities", ["getStaticEntities"]),
    ...mapGetters("Entities", {
      getStaticEntitiesMeta: "getStaticEntities",
    }),
    ...mapGetters("Comments", ["getComments", "getCommentMode"]),
    // generates the list of layers needs to be renderd for the current group
    getEntitiesForSearch() {
      if (this.getStaticEntitiesMeta && this.getStaticEntitiesMeta.length > 0) {
        const currentEntity = this.getStaticEntitiesMeta[0];
        return [
          {
            name: currentEntity.name,
            id: currentEntity.id,
            entities: this.getStaticEntities.map((item) => ({
              ...item,
              name: item.id,
            })),
          },
        ];
      } else {
        return [];
      }
    },
  },
  methods: {
    ...mapActions("StaticEntity", ["refetchAllData"]),
    ...mapActions("Entities", ["fetchStaticEntities"]),
    ...mapActions("Location", ["setActiveCity", "fetchCityForLatLong"]),
    ...mapActions("Comments", ["setEditComment", "setShowComment"]),
    selectStaticEntity(entity) {
      this.selectedStaticEntities = [...this.selectedStaticEntities, entity];
    },
    setPopUpData(data) {
      this.popUpData = data;
    },
    setContextData(data) {
      this.contextData = data;
    },
    showAddCommentPopup(data) {
      this.setEditComment(data);
      // this.commentData = data;
    },
    changeMagicLink(link) {
      this.magic_link = link;
    },
    closePopUp() {
      this.setPopUpData({ show: false });
    },
    closeContext() {
      this.setContextData({ show: false });
    },
    handleClick(info, event) {
      // If not clicked on Static Entity, close the popup:
      if (!info.picked) this.closePopUp();

      // If rightclicked, show copy coordinates context menu:
      if (event && event.rightButton) {
        const { coordinate, x, y } = info;
        this.setContextData({
          x,
          y: y + 0, // Added offset for the topbar
          data: {
            coordinate,
          },
          show: true,
        });
      } else {
        this.setContextData({ show: false });
      }
    },
    returnLayers() {
      // TODO: Based on the active layer, return layers. e.g. event_totals with x will have different view
      const point = new ScatterplotLayer({
        id: `${this.getActiveLayers["primary"]} location-point`,
        data:
          this.getStaticEntities && this.getStaticEntities.length > 0
            ? this.getStaticEntities
            : [],
        pickable: true,
        opacity: 0.8,
        stroked: false,
        filled: true,
        radiusScale: 6,
        radiusMinPixels: 0.5,
        radiusMaxPixels: 110,
        // lineWidthMinPixels: 20,
        getPosition: (d) => [d.geo[1], d.geo[0]],
        getRadius: (d) => {
          if (
            d.analyses &&
            this.getActiveLayers["primary"] &&
            d.analyses[this.getActiveLayers["primary"]]
          ) {
            // Individual Single Values are present and there is a layer:
            if (d.analyses[this.getActiveLayers["primary"]].data !== "-") {
              return (
                10 + d.analyses[this.getActiveLayers["primary"]].normalizedData
              );
            } else return 10;
          } else return 10;
        },

        getFillColor: (d) => {
          return [255, 151, 10, 200];
          // return [0, 255, 164, 100];
        },
        getLineColor: (d) => [3, 165, 252, 100],
        onHover: (info, event) => {
          // If the popup is pinned, don't listen to hover events:
          if (this.popUpData.pinned) return;

          // If hovering over a static entity, show the popup:
          if (info.picked && info.object) {
            const { x, y } = info;

            const { object } = info;
            let metaAndAnalysisData = {};

            // Adding static entity meta data:
            const metaData = Object.entries(object.meta).reduce(
              (obj, [key, value]) => ({
                ...obj,
                [key.split("__")[1]]: value,
              }),
              {}
            );
            metaAndAnalysisData = { ...metaData };

            // Adding Individual analysis value:
            this.getLayers.forEach((layer) => {
              metaAndAnalysisData[layer.name] =
                object.analyses && object.analyses[layer.id]
                  ? object.analyses[layer.id].data
                  : "";
            });

            this.setPopUpData({
              show: true,
              x,
              y,
              metadata: metaAndAnalysisData,
              title: "Entity Id",
              value: object.id,
              icon: "train",
            });
          } else {
            // If not hovering over a static entity, hide the popup:
            this.setPopUpData({
              show: false,
            });
          }
        },
        onClick: (info, event) => {
          // If clicked on a static entity, pin the popup:
          if (info.picked && info.object) {
            const { x, y } = info;
            const { object } = info;

            let metaAndAnalysisData = {};

            // Adding static entity meta data:
            const metaData = Object.entries(object.meta).reduce(
              (obj, [key, value]) => ({
                ...obj,
                [key.split("__")[1]]: value,
              }),
              {}
            );
            metaAndAnalysisData = { ...metaData };

            // Adding Individual analysis value:
            this.getLayers.forEach((layer) => {
              metaAndAnalysisData[layer.name] =
                object.analyses && object.analyses[layer.id]
                  ? object.analyses[layer.id].data
                  : "";
            });
            const data = this.setPopUpData({
              show: true,
              x,
              y,
              metadata: metaAndAnalysisData,
              title: "Entity Id",
              value: object.id,
              icon: "bubble_chart",
              pinned: true,
            });
          }
        },
      });

      // const text = new TextLayer({
      //   layer_id: this.layer_id,
      //   data: this.getStaticEntities,
      //   dataTransform: (data) => data.features,
      //   getText: (d) => `${d.id}`,
      //   getPosition: (d) => [d.geo[1], d.geo[0]],
      //   getColor: (d) => [255, 255, 255],
      //   getSize: (d) => 20,
      //   sizeScale: 1,
      //   getPixelOffset: [0, 15],
      // });
      const subwayColors = {
        A: [0, 57, 166],
        C: [0, 57, 166],
        E: [0, 57, 166],
        B: [255, 99, 25],
        D: [255, 99, 25],
        F: [255, 99, 25],
        M: [255, 99, 25],
        G: [108, 190, 69],
        J: [153, 102, 51],
        Z: [153, 102, 51],
        L: [167, 169, 172],
        N: [252, 204, 10],
        Q: [252, 204, 10],
        R: [252, 204, 10],
        S: [128, 129, 31],
        "1": [238, 53, 46],
        "2": [238, 53, 46],
        "3": [238, 53, 46],
        "4": [0, 147, 60],
        "5": [0, 147, 60],
        "6": [0, 147, 60],
        "7": [185, 51, 173],
      };
      const subwayLines = new PathLayer({
        id: "path-layer",
        data:
          "https://villages-28.s3.ap-south-1.amazonaws.com/app-assets/nyc_subway_lines.geojson",
        dataTransform: (data) => {
          return data.features.map((feature) => {
            return {
              name: feature.properties.name,
              path: feature.geometry.coordinates,
              color: subwayColors[feature.properties.rt_symbol] || [
                255,
                255,
                0,
              ],
            };
          });
        },
        widthScale: 20,
        widthMinPixels: 2,
        getPath: (d) => d.path,
        getColor: (d) => d.color,
        getWidth: (d) => 2,
      });

      const ICON_MAPPING = {
        comment: { x: 0, y: 0, width: 100, height: 100, mask: false },
      };
      const commentLayer = new IconLayer({
        id: "comments-layer",
        data: this.getComments,
        pickable: true,
        iconAtlas: "/comment-icon.png",
        iconMapping: ICON_MAPPING,
        getIcon: (d) => "comment",
        getPosition: (d) => [...d.geometry.coordinates].reverse(),
        sizeScale: 5,
        getSize: (d) => 10,
        onHover: (info, e) => {
          const { object, x: layerX, y: layerY } = info;
          if (object && object.comment_id) {
            this.setShowComment({
              show: true,
              comment: object,
              x: layerX,
              y: layerY,
            });
          } else {
            this.setShowComment({
              show: false,
              x: 0,
              y: 0,
            });
          }
        },
        onClick: (info, e) => {
          if (this.getCommentMode !== "EDIT") return;
          if (e && e.rightButton) return;

          const { object, x: layerX, y: layerY } = info;

          console.log({ object });
          if (!object) {
            return;
          }
          this.setEditComment({
            ...object,
            mode: "EDIT",
            screenLocation: {
              x: layerX,
              y: layerY,
            },
          });
        },
      });

      if (this.isMeasureModeEnabled) {
        const measureDistance = new DistanceToolLayer({
          layer_id: "MeasureDistance",
          data: this.measure_data,
          updateState: (value) => {
            this.measure_data = value;
          },
        });
        const distanceLayer = measureDistance.getLayer();
        return [subwayLines, point, commentLayer, distanceLayer];
      } else {
        return [subwayLines, point, commentLayer];
      }
    },

    toggleSharePopup() {
      this.showSharePopup = !this.showSharePopup;
    },
    toggleGeoSearch() {
      this.showGeoSearch = !this.showGeoSearch;
    },
    toggleMeasureDistance(vlaue) {
      this.showMeasureDisatanceTool = value;
    },
    handleGeoSelection(selection) {
      if (selection.selection_type && selection.selection_type.mode) {
        switch (selection.selection_type.mode) {
          case "mapbox":
            this.zoom = selection.selection_type.zoom || 12;
            [this.latitude, this.longitude] = [
              ...selection.selection_type.location,
            ].reverse();
            this.setCityforLatLong(
              selection.selection_type.location,
              selection.bbox || [selection.center] || [
                  selection.selection_type.location,
                ]
            );
            break;
          case "coordinates":
            this.zoom = selection.selection_type.zoom || 16;
            [this.latitude, this.longitude] = [
              ...selection.selection_type.location,
            ].reverse();
            this.setCityforLatLong(selection.selection_type.location, null);
            break;
          case "entity":
            this.zoom = selection.selection_type.zoom || 16;
            [this.latitude, this.longitude] = [...selection.geo];
            this.setCityforLatLong([...selection.geo].reverse(), null);
            break;
        }
      }
    },
    async setCityforLatLong(latlong, bbox) {
      const city = await this.fetchCityForLatLong(latlong);
      console.log(city);
      const cityModel = new City({
        city_id: city.city_id,
        city: city.city,
        state: city.state || null,
        bbox: city.bbox || bbox || [latlong], // set the bbox to any of the mentioned
        latlong: latlong.reverse(),
        zoom: 12,
      });
      if (city) {
        this.setActiveCity(cityModel);
        this.refetchAllData();
      }
    },
  },
  watch: {
    getActiveCity: {
      immediate: true,
      handler(city) {
        if (!city) return;
        if (this.watchActiveCity) {
          if (city.latlong && city.zoom) {
            // Just update lat long and zoom if present, for the first time
            this.zoom = city.zoom;
            this.latitude = city.latlong[0];
            this.longitude = city.latlong[1];
          } else {
            console.error(
              "lat_lon and zoom_level are not present in the console city meta"
            );
          }
          this.watchActiveCity = false;
        }
      },
    },
    getActiveLayers: {
      immediate: false,
      handler(activeLayers) {
        // console.warn("Layer Changed, check for analyses data");
        if (
          this.getStaticEntities.length > 0 &&
          this.getStaticEntities[0].analyses &&
          this.getStaticEntities[0].analyses[activeLayers["primary"]]
        ) {
          // console.warn("Static Entity data present, re render the layers");
          this.layers = this.returnLayers();
        }
      },
    },
    getStaticEntities(staticEntities) {
      // console.warn("StaticEntities Changed, re render the layers");
      this.layers = this.returnLayers();
    },
    getComments() {
      this.layers = this.returnLayers();
    },
    isMeasureModeEnabled() {
      this.layers = this.returnLayers();
    },
  },
  created: function () {
    // console.warn("Console created, render the layers");
    this.layers = this.returnLayers();
  },
  mounted: function () {
    this.magic_link = this.getCurrentConsole.magic_link;
  },
};
</script>

<style lang="scss" scoped>
.analysis-studio {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background: var(--color-secondary);

  .layout-grid {
    display: grid;
    grid-template-rows: 50px 1fr;
    height: 100%;

    .content-layout {
      background: var(--color-primary);
      display: grid;
      max-width: 100%;
      height: 100%;
      grid-template-columns: 350px 1fr;
      min-height: 0; /* NEW */
      min-width: 0;
      background: var(--color-default-background);
      position: relative;

      .content-area {
        position: relative;
      }
    }
  }

  // .top-bar {
  //   height: 66px;
  //   background: var(--color-secondary);
  // }

  // .content-area {
  //   flex: 1;
  //   position: relative;
  //   height: 100%;
  //   background: var(--color-primary);
  // }
}
</style>
